<template>
  <div class="resume-form">
    <van-cell-group inset>
      <van-field
        name="返校时间"
        label="返校时间"
        placeholder="请选择"
        input-align="right"
        required
        is-link
        readonly
        v-model="callbackDateTime"
        @click="showPickerDateTimeEvt"
      />
      <van-field
        name="是否返校"
        label="是否返校"
        placeholder="请选择"
        input-align="right"
        border
      >
        <template #input>
          <van-radio-group v-model="isCallback" direction="horizontal">
            <van-radio name="true">
              <template #icon="props">
                <van-image
                  class="img-icon"
                  width="18px"
                  height="18px"
                  :src="
                    props.checked
                      ? require('@/assets/image/common/checked.png')
                      : require('@/assets/image/common/un_checked.png')
                  "
                />
              </template>
              是
            </van-radio>
            <van-radio name="false">
              <template #icon="props">
                <van-image
                  class="img-icon"
                  width="18px"
                  height="18px"
                  :src="
                    props.checked
                      ? require('@/assets/image/common/checked.png')
                      : require('@/assets/image/common/un_checked.png')
                  "
                />
              </template>
              否
            </van-radio>
          </van-radio-group>
        </template>
      </van-field>
    </van-cell-group>

    <van-popup v-model:show="showPickerApplicationDate" position="bottom">
      <van-picker
        title="返校时间"
        :columns="dateTimeColumns"
        @confirm="onConfirmApplicationDate"
        @cancel="onCancleApplicationDate"
      />
    </van-popup>
  </div>
</template>

<script>
import Time from "@/utils/time.js";
import { ref, reactive } from "vue";
export default {
  name: "ResumeForm",
  setup() {
    const callbackDateTime = ref("");
    const showPickerDateTimeEvt = () => {
      showPickerApplicationDate.value = true;
    };

    const isCallback = ref(false);

    // 时间选择器显示隐藏
    const showPickerApplicationDate = ref(false);
    const onConfirmApplicationDate = (values) => {
      let [date, h, m] = values;

      callbackDateTime.value = `${date} ${h}:${m}`;
      showPickerApplicationDate.value = false;
    };
    const onCancleApplicationDate = () => {
      showPickerApplicationDate.value = false;
    };

    const formatTimeColumns = () => {
      let dateArr = [];
      for (let i = 0; i < 60; i++) {
        let curDateTime = new Date().getTime() + 24 * 60 * 60 * 1000 * i;
        let curDate = Time.formatDate(new Date(curDateTime));
        dateArr.push(curDate);
      }

      let hArr = [];
      for (let i = 0; i < 24; i++) {
        let h = "";
        if (i <= 9) {
          h = "0" + i;
        } else {
          h = i + "";
        }
        hArr.push(h);
      }

      let mArr = [];
      for (let i = 0; i < 60; i++) {
        let m = "";
        if (i <= 9) {
          m = "0" + i;
        } else {
          m = i + "";
        }
        mArr.push(m);
      }

      return [
        {
          values: dateArr,
          defaultIndex: 1,
        },
        {
          values: hArr,
          defaultIndex: new Date().getHours(),
        },
        {
          values: mArr,
          defaultIndex: new Date().getMinutes(),
        },
      ];
    };
    const dateTimeColumns = reactive(formatTimeColumns());

    return {
      callbackDateTime,
      showPickerDateTimeEvt,
      isCallback,
      showPickerApplicationDate,
      onConfirmApplicationDate,
      onCancleApplicationDate,
      dateTimeColumns,
    };
  },
};
</script>

<style lang="less" scoped>
.resume-form {
  width: 100%;
}

/deep/ .van-cell-group--inset {
  margin: 0;
  .van-cell {
    padding: 10px 0;
  }
}

/deep/ .van-field__label {
  color: #333;
}
/deep/ .van-field__body input {
  text-align: right;
}
</style>
